import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface UserInfoBlockProps {
  id: string;
  issue: string;
  browser: string;
  settings?: string[];
}

const UserInfoBlock: FC<UserInfoBlockProps> = ({ id, issue, browser, settings }) => {
  const [t] = useTranslation('reported');
  const [c] = useTranslation('widget');

  return (
    <div className={styles['user-info-block']}>
      <div>
        <span>{t('userId')}:</span> <span>{id}</span>
      </div>
      <div>
        <span>{t('issue')}:</span> <span>{issue}</span>
      </div>
      <div>
        <span>{t('browser')}:</span> <span className={styles['capitalize-text']}>{browser}</span>
      </div>
      <div>
        <span>{t('widgetSettings')}:</span>{' '}
        {settings?.length && Array.isArray(settings)
          ? settings?.map((item, idx) => (
              <span key={item}>
                {c(`${item}Initial`)}
                {idx < settings.length - 1 ? '; ' : ''}
              </span>
            ))
          : t('emptyWidgetSettings')}
      </div>
    </div>
  );
};

export default UserInfoBlock;
